module.exports = __webpack_public_path__ + "static/kreditvermittlung-5ffaadf5ec1e177f34827952866dba5a.pdf";